__turbopack_context__.v({
  "card": "EventCard-module-scss-module__AI7g2G__card",
});
